import { Rate } from "antd"
import styled from "styled-components"

const RateField = styled(Rate)`
  width: 100%
`

export { RateField }
